import { CircularProgress, Grid, IconButton } from "@material-ui/core";
import { Close, PhotoCamera } from "@material-ui/icons";
import { getOrientation } from "get-orientation/browser";
import PropTypes from "prop-types";
import React from "react";
import AppService from "../../Services/AppService/AppService";
import CropImageDialog from "./cropImageDialog";
import { InputImageProvider } from "./InputImageContext";
import { getRotatedImage } from "./rotateImage";
import "./style.css";
import { useInputImageId } from "./useInputImageId";

const ORIENTATION_TO_ANGLE = {
  3: 180,
  6: 90,
  8: -90,
};

const InputImage = (props) => {
  const {
    image,
    maxSize,
    aspectW,
    aspectH,
    removeType,
    onUploadDone,
    onRemove,
    style,
    styleWrapper,
    styleImage,
    disabled,
  } = props;
  const [availableImage, setAvailableImage] = React.useState(image);
  const [isError, setIsError] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [isLoading, setLoading] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [imageSrc, setImageSrc] = React.useState("");
  const refInputImage = React.useRef();
  const componentID = useInputImageId();
  const cropData = {
    aspectW: aspectW,
    aspectH: aspectH,
  };

  const handleOnChangeFile = async (event) => {
    setErrorMessage("");
    setIsError(false);
    if (props.onChange) props.onChange(event.target.value);

    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (file.size <= maxSize * 1024) {
        let imageDataUrl = await readFile(file);

        // apply rotation if needed
        const orientation = await getOrientation(file);
        const rotation = ORIENTATION_TO_ANGLE[orientation];
        if (rotation) {
          imageDataUrl = await getRotatedImage(imageDataUrl, rotation);
        }
        setImageSrc(imageDataUrl);
        setErrorMessage("");
        setIsError(false);
        setOpen(true);
      } else {
        setErrorMessage("Max file size " + maxSize + "kb ");
        setIsError(true);
      }
    }
  };

  const handleClickRemove = () => {
    switch (removeType) {
      case "delete":
        onRemove(availableImage);
        break;
      default:
        setAvailableImage("");
        setLoading(false);
        setIsError(false);
        setErrorMessage("");
        refInputImage.current.value = null;
        setOpen(false);
        onRemove(availableImage);
        break;
    }
  };

  const uploadImage = (image) => {
    console.log(image);
    console.log(">>>>>>>>>>>>>?<<<<<<<<");
    return new Promise((resolve) => {
      AppService.uploaderFile({ file: image })
        .then((response) => {
          setLoading(false);
          setIsError(false);
          setAvailableImage(response.data.url);
          onUploadDone(response.data.url);
          resolve(true);
        })
        .catch((error) => {
          setLoading(false);
          setIsError(true);
          setErrorMessage(error);
          resolve(false);
        });
    });
  };

  const handleSaveImage = (image) => {
    setAvailableImage("");
    setLoading(true);
    uploadImage(image);
    refInputImage.current.value = null;
    setOpen(false);
  };

  const handleCloseDialog = () => {
    setAvailableImage("");
    refInputImage.current.value = null;
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Grid item className="input-image" style={style}>
        <div className="input-image-wrapper" style={styleWrapper}>
          {availableImage !== "" && !isLoading && !isError && (
            <img
              alt="Foto"
              className="image-preview"
              src={availableImage}
              style={styleImage}
            />
          )}
          <input
            type="file"
            key={componentID}
            className="input-file-image"
            id={`icon-button-file-${componentID}`}
            accept="image/x-png,image/gif,image/jpeg"
            onChange={(event) => handleOnChangeFile(event)}
            ref={refInputImage}
            disabled={disabled ? true : false}
          />

          {!isLoading && availableImage === "" && (
            <label htmlFor={`icon-button-file-${componentID}`}>
              <IconButton
                color="primary"
                aria-label="upload picture"
                component="span"
              >
                <PhotoCamera />
              </IconButton>
            </label>
          )}

          {isLoading && availableImage === "" && (
            <React.Fragment>
              <CircularProgress />
              <small style={{ marginTop: "12px" }}>Uploading</small>
            </React.Fragment>
          )}

          {isError && (
            <small className="error">{`${
              errorMessage || "Something Error"
            }`}</small>
          )}
          {!isLoading && availableImage !== "" && (
            <IconButton
              aria-label="remove"
              className="remove"
              size="small"
              onClick={() => {
                if (!disabled) {
                  handleClickRemove();
                }
              }}
            >
              <Close />
            </IconButton>
          )}
        </div>
      </Grid>
      <InputImageProvider value={cropData}>
        <CropImageDialog
          open={open}
          image={imageSrc}
          onCropDone={(image) => handleSaveImage(image)}
          onCropCancel={() => handleCloseDialog()}
        />
      </InputImageProvider>
    </React.Fragment>
  );
};

function readFile(file) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => resolve(reader.result), false);
    reader.readAsDataURL(file);
  });
}

InputImage.propType = {
  image: PropTypes.string,
  maxSize: PropTypes.number,
  aspectH: PropTypes.number,
  aspectW: PropTypes.number,
  removeType: PropTypes.string,
  onUploadDone: PropTypes.func,
  onRemove: PropTypes.func,
};

export default InputImage;
